/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import * as ArrayUtil from 'fierry/util/array';

import ZoneUserControl from 'solis/logic/board/zone/user.control';


export default class ZoneUsers extends Logic
{
  getColonyUser ()
  {
    return this.object.getColony().cass.user;
  }


  getCurrentUser ()
  {
    return this.object.cass.currentUser;
  }


  getOriginUser ()
  {
    return this.object.getSector().cass.originUser;
  }


  getSectorUser ()
  {
    return this.object.getSector().cass.currentUser;
  }


  isColonyUser (user)
  {
    return this.getColonyUser() === user;
  }


  isCurrentUser (user)
  {
    return this.getCurrentUser() === user;
  }


  isOriginUser (user)
  {
    return this.getOriginUser() === user;
  }


  isOriginOccupied ()
  {
    return this.getOriginUser() !== this.getCurrentUser();
  }


  isSectorOccupied ()
  {
    return this.getSectorUser() !== this.getCurrentUser();
  }


  isEstablished (user)
  {
    const users = this.getEstablishedUsers();

    return users.length === 0 || users.includes(user);
  }


  isContested ()
  {
    return this.getInfluenceUsers().some(user => user !== this.getCurrentUser());
  }


  getChallengers ()
  {
    return this.getActiveUsers().filter(user => user !== this.getCurrentUser());
  }


  getActiveUsers ()
  {
    return [ ...new Set([ ...this.getControlUsers(), ...this.getInfluenceUsers() ]) ];
  }


  getControlUsers ()
  {
    return this.object.cass.control.map(control => control.user);
  }


  getInfluenceUsers ()
  {
    return [ ...new Set(this.object.getInfluences().values().map(influence => influence.getSourceUserID())) ];
  }


  getEstablishedUsers ()
  {
    const influences = this.object.getInfluences().values().filter(influence => influence.cass.established);

    return influences.map(influence => influence.getSourceUserID());
  }


  getInfluenceWinner ()
  {
    const found = ArrayUtil.findMax(this.getInfluenceUsers(), (user) =>
    {
      return new ZoneUserControl(this.object, user).getInfluence();
    });

    return found !== null ? found : this.getCurrentUser();
  }


  // QQ not sure if this should be here...
  isNeighborAccessible (proximity, sourceColony)
  {
    if (proximity.isAccessibleByColony(this.object.getAbsoluteHex(), sourceColony))
    {
      return true;
    }

    for (const neighbor of this.object.getAbsoluteHex().getNeighbors())
    {
      if (proximity.isAccessibleByColony(neighbor, sourceColony))
      {
        return true;
      }
    }

    return false;
  }


};
